import RemoteEvaluateResult from "./RemoteEvaluateResult"
import RemoteConfigEvaluation from "../../../evaluation/service/remoteconfig/RemoteConfigEvaluation"
import RemoteConfigEvaluateResult from "../../../evaluation/service/remoteconfig/RemoteConfigEvaluateResult"
import Evaluation from "../../../evaluation/Evaluation"
import Entity from "../../../model/Entity"
import { DecisionReason,
  AbstractRemoteConfigParameter,
  MatchValueType,
  RemoteConfigParameterValue
} from "../../../model/model"

/**
 * Server-resolved remote-config result. Is both the parameter (a `RemoteConfigParameter`) and its
 * own pre-resolved result, and flattens into a `RemoteConfigEvaluation` as-is.
 */
export default class RemoteConfigParameterRemoteEvaluateResult
  extends AbstractRemoteConfigParameter
  implements RemoteEvaluateResult, RemoteConfigEvaluateResult
{
  constructor(
    readonly id: number,
    readonly key: string,
    readonly type: MatchValueType,
    readonly value: RemoteConfigParameterValue | undefined,
    readonly reason: DecisionReason,
    readonly references: Entity[]
  ) {
    super()
  }

  toEvaluation(): Evaluation {
    return new RemoteConfigEvaluation(this, this)
  }
}
